import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { IMaterial } from '../../../../Interfaces/IResultado';
import { useNavigate } from 'react-router-dom';


interface Props {
  material: IMaterial;
  setModalMaterialCopy: Dispatch<SetStateAction<string>>;
  setModalMaterialesAdvice: Dispatch<SetStateAction<boolean>>;
  setCurrentItemModal: Dispatch<SetStateAction<string>>;
  setLinkPdfAlimentacion: Dispatch<SetStateAction<string>>;
  seconds: number;
}

const getCardVariant = (url: string | undefined): string => {
  switch (url) {
    case '/aceleradores': return 'fit4-module-card--accent';
    case '/misRutinas': return 'fit4-module-card--train';
    case '/planAlimentacion': return 'fit4-module-card--food';
    case '/preguntasFrecuentes': return 'fit4-module-card--faq';
    case '/tuProgreso': return 'fit4-module-card--progress';
    case '/podcasts': return 'fit4-module-card--audio';
    default: return 'fit4-module-card--save';
  }
};

const MaterialSection = ({material, setModalMaterialCopy, setModalMaterialesAdvice, setCurrentItemModal, setLinkPdfAlimentacion, seconds} : Props) => {

  const navigate = useNavigate();
  const variant = getCardVariant(material.url);

  function handleOpenMaterial(
    copy: string,
    linkdf: string,
    url?: string,
    pdfBono?: boolean,
  ) {
    if (url === '/misRutinas' && seconds > 0) {
      setModalMaterialCopy(copy);
      setModalMaterialesAdvice(true);
      setCurrentItemModal('rutinas');
      return;
    }
    if (url === '/planAlimentacion' && seconds > 0) {
      setModalMaterialCopy(copy);
      setModalMaterialesAdvice(true);
      setCurrentItemModal("alimentacion");
      return;
    }

    if (pdfBono) {
      window.open(linkdf, '_blank'); // abre la URL en una nueva pestaña
      return;
    }

    if (linkdf) {
      if (seconds > 0) {
        setModalMaterialCopy(copy);
        setModalMaterialesAdvice(true);
        setCurrentItemModal('alimentacion');
        setLinkPdfAlimentacion(linkdf);
      } else {
        window.open(linkdf, '_blank'); // abre la URL en una nueva pestaña
      }
    } else {
      if (url) {
        switch (url) {
          case '/misRutinas':
            navigate('/misRutinas');
            window.scrollTo(0, 0);
            localStorage.setItem('habilitarRutinas', String(true));
            break;
          case '/podcasts':
            navigate('/podcasts');
            window.scrollTo(0, 0);
            break;
          case '/preguntasFrecuentes':
            navigate('/preguntasFrecuentes');
            window.scrollTo(0, 0);
            break;
          case '/planAlimentacion':
            navigate('/planAlimentacion');
            window.scrollTo(0, 0);
            break
          case '/aceleradores':
            navigate('/aceleradores');
            window.scrollTo(0, 0);
            break
          case '/tuProgreso':
            navigate('/tuProgreso');
            window.scrollTo(0, 0);
          default:
            break;
        }
      }
    }
  }

  return (
    <section
      className={`fit4-module-card ${variant}`}
      onClick={() => {
        handleOpenMaterial(
          material.copy,
          material.pdfLink,
          material.url,
          material.pdfBono && true,
        );
      }}
    >
      {/* Icon */}
      <div className="fit4-module-icon">
        <img
          src={material.imgFromProject}
          alt=""
        />
      </div>

      {/* Text */}
      <div className="fit4-module-text">
        <p className="fit4-module-title">{material.title}</p>
        {material.subtitle && (
          <p className="fit4-module-subtitle">{material.subtitle}</p>
        )}
      </div>

      {/* Arrow */}
      <svg className="fit4-module-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </section>
  )
}

export default MaterialSection